// extracted by mini-css-extract-plugin
module.exports = {"ad-slot":"organism3-m__ad-slot__37RiH","widget-wrapper":"organism3-m__widget-wrapper__biKQ3","widget-iframe":"organism3-m__widget-iframe__1m0Lc","base":"organism3-m__base__1grb5"};